export default (types, prefix = '') => {
  if (!Array.isArray(types)) {
    throw new Error('defineTypes(...): Argument must be an array.');
  }

  prefix = prefix ? `${prefix}/` : '';

  return types.reduce(
    (acc, type) => ({ ...acc, [type]: `${prefix}${type}`.toUpperCase() }),
    {},
  );
};
